// Module
var code = `<div class="indicatorLookupDropDownForm">
    <div class="header_indicator_lookupDropDownForm">
        <terceraTextBox name="textBox" isMaterialDesign="false" svgIcon="search"/>
    </div>

    <div class="body_indicator_lookupDropDownForm">
        <terceraQuickTree name="quickTree" boldRootNode="true" />
    </div>

    <div class="footer_indicator_lookupDropDownForm">
        <div class="lableContainer_indicator_lookupDropDownForm">
            <terceraLabel name="labelCount" text="{{.labelCountText}}" />
        </div>
        <div class="addCancelBtnContainer_indicator_lookupDropDownForm">
            <terceraButton name="addBtn" terceraButtonStyle="js-button-ok style-width-100" on-componentClick="@this.onAddIndicatorBtnClicked()" enabled="{{.enabledAddBtn}}" text="{{.addBtnText}}" />
            <terceraButton terceraButtonStyle="js-button-gray25 style-width-100" on-componentClick="@this.close()" text="{{.cancelBtnText}}" />
        </div>
    </div>
</div>`;
// Exports
export default code;